import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ScrollToTop from "@/components/base/ScrollToTop";
import Seo from "@/components/base/Seo";
import { faqItems } from "@/mocks/faq";
import { getLatestArticles } from "@/lib/content";
import HeroSection from "./components/HeroSection";
import TickerStrip from "./components/TickerStrip";
import FocusSection from "./components/FocusSection";
import LatestStream from "./components/LatestStream";
import CategoryGrid from "./components/CategoryGrid";
import RecommendedGrid from "./components/RecommendedGrid";
import EditorPicks from "./components/EditorPicks";
import SubscribeBlock from "./components/SubscribeBlock";
import TestimonialWall from "./components/TestimonialWall";
import FaqSection from "./components/FaqSection";

const ORIGIN = "https://sjlm888.cn";

export default function Home() {
  const latest = getLatestArticles(8);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "51吃瓜",
      url: `${ORIGIN}/`,
      inLanguage: "zh-CN",
      description:
        "51吃瓜每日更新今日新鲜瓜，新瓜推荐、定时开吃、热门事件实时同步，汇聚全网最新瓜田信息。",
      potentialAction: {
        "@type": "SearchAction",
        target: `${ORIGIN}/rank?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "51吃瓜",
      url: `${ORIGIN}/`,
      slogan: "今日新鲜瓜，一看便知",
      email: "hello@51chigua.example.com",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日新瓜推荐",
      itemListElement: latest.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${ORIGIN}/article/${item.id}`,
        name: item.title,
      })),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="51吃瓜 - 51吃瓜今日新鲜瓜，今天有什么瓜实时更新一看便知"
        description="51吃瓜每日更新今日新鲜瓜，今天有什么瓜一搜便知。新瓜推荐、定时开吃、热门事件实时同步，汇聚全网最新瓜田信息，吃瓜群众不迷路。"
        keywords="51吃瓜,51吃瓜今日新鲜瓜,51吃瓜今天有什么瓜,51吃瓜每日新瓜,今日新鲜瓜,娱乐热点"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <TickerStrip />
        <FocusSection />
        <LatestStream />
        <CategoryGrid />
        <RecommendedGrid />
        <EditorPicks />
        <SubscribeBlock />
        <TestimonialWall />
        <FaqSection />
      </main>
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}